// extracted by mini-css-extract-plugin
module.exports = {"horizontalFlexBox":"global_horizontalFlexBox__1vKjw","verticalFlexBox":"global_verticalFlexBox__1RMJa"};